import DOMPurify from "dompurify";

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const categoryColors = [
  {
    bg: "bg-blue-500",
    text: "text-blue-600 dark:text-blue-300",
    soft: "bg-blue-50 dark:bg-blue-500/10",
    border: "border-blue-200 dark:border-blue-500/20",
    gradient: "from-blue-500 via-sky-500 to-cyan-400",
  },
  {
    bg: "bg-orange-500",
    text: "text-orange-600 dark:text-orange-300",
    soft: "bg-orange-50 dark:bg-orange-500/10",
    border: "border-orange-200 dark:border-orange-500/20",
    gradient: "from-orange-500 via-amber-500 to-yellow-400",
  },
  {
    bg: "bg-emerald-500",
    text: "text-emerald-600 dark:text-emerald-300",
    soft: "bg-emerald-50 dark:bg-emerald-500/10",
    border: "border-emerald-200 dark:border-emerald-500/20",
    gradient: "from-emerald-600 via-teal-500 to-cyan-400",
  },
  {
    bg: "bg-purple-500",
    text: "text-purple-600 dark:text-purple-300",
    soft: "bg-purple-50 dark:bg-purple-500/10",
    border: "border-purple-200 dark:border-purple-500/20",
    gradient: "from-purple-600 via-fuchsia-500 to-pink-400",
  },
  {
    bg: "bg-rose-500",
    text: "text-rose-600 dark:text-rose-300",
    soft: "bg-rose-50 dark:bg-rose-500/10",
    border: "border-rose-200 dark:border-rose-500/20",
    gradient: "from-rose-600 via-red-500 to-orange-400",
  },
  {
    bg: "bg-indigo-500",
    text: "text-indigo-600 dark:text-indigo-300",
    soft: "bg-indigo-50 dark:bg-indigo-500/10",
    border: "border-indigo-200 dark:border-indigo-500/20",
    gradient: "from-indigo-600 via-blue-500 to-sky-400",
  },
];

export function getCategoryStyle(index = 0) {
  return categoryColors[index % categoryColors.length];
}

export function toAbsoluteTeamPhoto(url) {
  if (!url) return "";

  const cleanUrl = String(url).trim();

  if (
    /^https?:\/\//i.test(cleanUrl) ||
    cleanUrl.startsWith("data:") ||
    cleanUrl.startsWith("blob:")
  ) {
    return cleanUrl;
  }

  const baseUrl = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";

  if (cleanUrl.startsWith("/")) {
    return `${baseUrl}${cleanUrl}`;
  }

  return `${baseUrl}/${cleanUrl}`;
}

export function stripHtml(html = "") {
  if (typeof window === "undefined") {
    return String(html || "").replace(/<[^>]*>/g, "").trim();
  }

  const div = document.createElement("div");
  div.innerHTML = html;

  return (div.textContent || div.innerText || "").trim();
}

export function hasMemberDetails(member) {
  return Boolean(
    (member?.bio_member && stripHtml(member.bio_member)) ||
      member?.tel_member ||
      member?.mail_member
  );
}

export function sanitizeBio(html = "") {
  return DOMPurify.sanitize(html || "", {
    USE_PROFILES: {
      html: true,
    },
    FORBID_ATTR: ["style"],
  });
}

export function getMemberFullName(member) {
  return `${member?.nom || ""} ${member?.prenom || ""}`.trim();
}

export function groupMembersByCategory(team = []) {
  const map = new Map();

  team.forEach((member) => {
    const category = member?.categorie?.trim() || "Autres";

    if (!map.has(category)) {
      map.set(category, []);
    }

    map.get(category).push(member);
  });

  return Array.from(map.entries());
}